import { removeDuplicates } from '@/constants';

export const foodIconsMixin = {
    computed: {
        displayedIcons() {
            let displayedIcons;

            if (!this.icons) {
                return [];
            }

            displayedIcons = this.icons
                .split('*')
                .filter(function (item) {
                    return item !== '';
                })
                .map((item) => {
                    let url = '';
                    url = `${this.$globalConstants.imageUrl}/img/meal_delivery_new/icons/${item}.svg`;
                    return { url: url, name: item };
                });

            return this.removeDuplicates(displayedIcons);
        },
    },
    methods: {
        iconUrl(icon) {
            return `${icon}?d=${this.dimensions.width.icon}x${this.dimensions.height.icon}`;
        },
        removeDuplicates(array) {
            return removeDuplicates(array);
        },
    },
};
